// extracted by mini-css-extract-plugin
export var button = "Contract-module--button--5ClgP";
export var component = "Contract-module--component--QgiXl";
export var content = "Contract-module--content--wFZrx";
export var label = "Contract-module--label--j85LB";
export var list = "Contract-module--list--gfa6I";
export var name = "Contract-module--name--C9KOF";
export var title = "Contract-module--title--9DLgR";
export var value = "Contract-module--value--a8h4v";